<template>
  <div class="reset-password-code">
    <b-container class="p-0 pm-2">
      <b-card class="card-login">
        <img v-if="logoSrc" :src="getImgUrl(logoSrc)" class="d-block mx-auto" />
        <h2 v-if="titleH2" class="mt-3 mb-4" v-html="titleH2"></h2>
        <b-row>
          <b-col>
            <h6 v-if="welcomeHeader" class="welecomeH6" v-bind:class="{
          'welecomeMIDH6 mt-5': guard == 'MID',
          'welecomeDYH6 mt-1 text-center': guard == 'DY',
          'welecomeDoorderH6 mt-5': guard == 'DOORDER',
          'welecomeAVH6 mt-3 text-center': guard == 'AV',
          'welcomeGHH6 mt-3': guard == 'GARDENHELP',
        }">
              {{ welcomeHeader }}
            </h6>
            <p v-if="welcomeSubheader" class="welcomeP" v-bind:class="{
          welecomeMIDP: guard == 'MID',
          'welecomeDYP mt-3': guard == 'DY',
          'welecomeDoorderP mb-3': guard == 'DOORDER',
          'welecomeAVP mt-3': guard == 'AV',
          'welcomeGHP mb-3': guard == 'GARDENHELP',
        }">
              {{ welcomeSubheader }}
            </p>
          </b-col>
        </b-row>
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col>
              <b-form-group  label-for="email"
                >
                <b-form-input id="code" class="form-control-auth" v-bind:class="{
          'form-control-auth-mid': guard == 'MID',
          'form-control-auth-doom-yoga': guard == 'DY',
          'form-control-auth-doorder': guard == 'DOORDER',
          'form-control-auth-astrology': guard == 'AV',
          'form-control-auth-garden-help': guard == 'GARDENHELP',
        }" v-model="form.code" type="text" :placeholder="$t('code')" autofocus required></b-form-input>
              </b-form-group></b-col></b-row>
          <input type="hidden" name="guard" v-model="guard" />
          <div class="d-flex justify-content-center align-content-center" v-bind:class="{
          'mt-5': guard === 'MID',
          'mt-2': guard === 'DY' || guard === 'DOORDER' || guard === 'AV',
          'submitButtonContainerGH mt-3': guard === 'GARDENHELP',
        }">
            <button class="btn" v-bind:class="{
          'btn-login-mid': guard === 'MID',
          'btn-login-dy': guard === 'DY',
          'btn-login-doorder': guard === 'DOORDER',
          'btn-login-av': guard === 'AV',
          'btn-login-garden-help': guard === 'GARDENHELP',
        }" type="submit">
              {{ $t('send_code_btn') }}
            </button>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ResetPasswordCode",
  props: [
    "titleH2",
    "logoSrc",
    "guard",
    "welcomeHeader",
    "welcomeSubheader",
    "clientLink",
  ],
  data() {
    return {
      form: {
        email: "",
        code: "",
        guard: this.guard,
      },
      user_type: "",
    };
  },
  mounted() {
    console.log(window.localStorage.getItem("user"));
    console.log(window.sessionStorage.getItem("email"));
    this.form.email = window.sessionStorage.getItem("email");

    this.user_type = this.$route.params.type;

  },
  methods: {
    getImgUrl(imgname) {
      // var images = require.context("@/assets/images/", false, /\.png$/);
      // return images("./" + imgname );

      return require("@/assets/images/" + imgname);
    },
    onSubmit() {
      console.log(window.localStorage);
      console.log("forget pssword submit");
      console.log(this.$parent.$parent.isLogin);
      console.log(this.form);
      if (this.user_type == 'admin') {
        axios
          .post(
            "admin/verify-reset-code",
            {
              email: this.form.email,
              client: this.form.guard,
              code: this.form.code,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                client: this.guard,
              },
            }
          )
          .then((response) => {
            console.log(response);
            console.log(response.data);
            window.sessionStorage.setItem("code", this.form.code)
            if (this.guard == "GARDENHELP") {
              this.$router.push({ name: "GardenHelpResetPassword", params: {
                  type: this.user_type === 'customer' ? 'user' : 'operator'
              }});
            }
            //   window.localStorage.setItem("user", JSON.stringify(response.data));
            // // this.$parent.$parent.isLogin = true;
            //   this.$router.go({ name: "DoOmYogaDashboard" });
          });
      } else {
        axios
          .post(
            "user/verfiy-otp-token",
            {
              email: this.form.email,
              client: this.form.guard,
              code: this.form.code,
            },
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                client: this.guard,
              },
            }
          )
          .then((response) => {
            console.log(response);
            console.log(response.data);
            window.sessionStorage.setItem("code", this.form.code)
            if (this.guard == "GARDENHELP") {
              this.$router.push({ name: "GardenHelpResetPassword" });
            }
            //   window.localStorage.setItem("user", JSON.stringify(response.data));
            // // this.$parent.$parent.isLogin = true;
            //   this.$router.go({ name: "DoOmYogaDashboard" });
          });

      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/auth/ResetPasswordCode.vue